// 实时视频对接新媒体平台建设文件
import { CHAT, ACION_REQUEST, websocketapp, setHandleHelmetOperationResponse } from '@/common/websocket/index'
import { warning, confirmWin, alertWin } from '@/util/common'
import store from '@/store/index'
import { getSession } from '@/api/common'
import { meetRegister, deleteMeet, searchMeet } from '@/api/mediaPlane'
import { extendMd } from '@/common/rtc/srs/jquery.md5'
import { HwRtcSignaling } from '@/common/rtc/srs/hwmedia.sig'
import { HwRtcPublisherAsync, HwRtcPlayerAsync } from '@/common/rtc/srs/hwmedia.sdk'
import i18n from '@/common/i18n'

/**
 * 声音关闭
 */
const VOLUME_OFF = 0
/**
 * 声音开启
 */
const VOLUME_ON = 1

var volume = 0

// 当前的房间号
let roomId = null

// 是否有麦克风设备
var hasMic = false

var clearTime = null

//最后一次关闭时间
let closeTime = null

var hasEnterRoom = false
// 请求进入房间有无响应延时提示
var closeNetTip = null
/**
 * 当前用户信息
 */
let current = {
  helmetId: null,
  resolutionP: null,
  userId: null,
  userName: null,
}

/**
 * 安全帽掉线处理逻辑
 */
let handleHelmetLeave = function() {}

/**
 * 外部设置 安全帽掉线处理逻辑
 * @param {Function} callback 安全帽掉线处理逻辑
 */
function setHandleHelmetLeave(callback) {
  handleHelmetLeave = callback
  // console.log('安全帽掉线处理逻辑' ,handleHelmetLeave)
}
// HTTP header 参数:
var busCode = null
var tokenData = null
var reqTime = null
var reqCode = null
var accessCode = null
var content = null
var sign = null

//创建webRtc推流对象
var publisher = null

// 会议码
var meetCode = null

var clientPlayers = {} //存放播放器对象

var lastestPlayers = {} //最新的客户端

// 获取随机6位数会议号
function getMeet() {
  roomId = randomNumstr(6)
}

// http 请求头参数
function handleHeader() {
  busCode = { busCode: roomId }

  tokenData = 'mspuser1'
  //req-time:
  reqTime = Math.floor(new Date().getTime() / 1000)
  reqCode = Number(parseInt(new Date().getTime() * Math.random() * 100))
    .toString(16)
    .substr(0, 7)
  // 验签码
  accessCode = 'abcdefg123456789'
  //待(加密)签名字符串
  content = tokenData + reqCode + reqTime + '{"busCode":"' + roomId + '"}' + accessCode
  // 加密sign
  sign = extendMd(content)
}

// 创建会议
async function registerAlone() {
  await getMeet()
  await handleHeader()
  meetRegister(busCode, tokenData, reqCode, reqTime, sign).then(res => {
    console.log('创建信令')
    if (res.state === 0) {
      meetCode = res.data.meetCode
      loginMVCPUtil(res.data.meetCode)
    }
  })
}

//创建信令===============================
var sig = new HwRtcSignaling()
var sigConnFlag = false
//开启打印日志
sig.openDebug()

//监听窗口关闭事件，当窗口关闭时，主动去关闭信令
window.onbeforeunload = function() {
  helmetExitMeet(current.helmetId)
  sig.wsClose()
}

var myMainToken = null
var wsUrl = null
var rtcUrl = null
var wsHost = null
/**
 * websocket与视频平台建立连接
 */
async function loginMVCPUtil(room) {
  wsUrl = store.getters.srsWsUrl
  let urlInfo = wsUrl.split('/')

  rtcUrl = urlInfo[2]
  console.log('信令meetcode', wsUrl, urlInfo, room, urlInfo[2])

  await checkMic()
  if (window.location.host.includes('localhost:808')) {
    // wsHost = 'wss://192.168.233.4/hwmsp/media/meetWS'
    wsHost = 'wss://intranet.iot.huaweisoft.com/hwmsp/media/meetWS'
    console.log(location.host)
    // wsHost = 'wss://' + location.host + '/meetWS'
  } else {
    wsHost = wsUrl + 'meetWS'
  }
  const clientCode = Number(parseInt(new Date().getTime() * Math.random() * 100))
    .toString(16)
    .substr(0, 7)
  const tokenMode = 0
  //检查信令对象
  if (sig.sigCheckAlive()) {
    // warning('信令仍然存活，不需要重新连接')
  } else {
    try {
      //信令连接.. 等待回调
      sigConnFlag = await sig.sigConnect(wsHost, room, clientCode, tokenMode)
      console.log('sigConnect...  sigConnFlag=' + sigConnFlag)
      if (sigConnFlag) {
        //获取令牌
        sig.myTokenInfo = await sig.sigQueryToken()
        sig.myToken = sig.myTokenInfo.myToken
        myMainToken = sig.myToken
        console.log(myMainToken, 'sig.myToken=' + sig.myTokenInfo)
      }
    } catch (e) {
      console.log('视频信令连接失败' + e)
    }
  }
}
// 离开会议 重新连接一个地址
function leaveRoomSelf() {
  clearTimeout(closeNetTip)
  if (document.getElementById('mvcpVideo')) {
    document.getElementById('mvcpVideo').srcObject = null
  }
  if (publisher) {
    publisher.close()
  }
  if (sig) {
    // 请求离开会议
    sig.sigReqDisconnect()
    sig.sigClose()

    setTimeout(() => {
      if (getSession('access_token')) {
        registerAlone()
      }
    }, 200)
  }
}
// 退出登录时 关闭信令
function loginOutCloseSig() {
  if (publisher) {
    publisher.close()
  }
  if (sig) {
    // 请求离开会议
    sig.sigReqDisconnect()
    sig.sigClose()
  }
}
// 通过会议码查询会议和客户端信息
async function getMeetInfo() {
  await handleHeader()
  searchMeet(meetCode, tokenData, reqCode, reqTime, sign).then(res => {
    console.log('通过会议码查询会议和客户端信息', res)
  })
}
//使用await发布视频
async function helmetJoinMeet(helmetId, resolutionP, userId, userName) {
  current = {
    helmetId,
    resolutionP,
    userId,
    userName,
  }
  await noticeHelmetMeet(helmetId, resolutionP)
  starPlay()
}
async function starPlay() {
  // { saveVideo: true, 是否保存录像 onVideo: false, 是否推流视频 onAudio: true 是否推流音频 }
  var paramJson = { outFlv: false, outHls: false, saveVideo: false, onVideo: false, onAudio: true }
  //请求推流
  sig.reqPublishResInfo = await sig.sigReqPublish(paramJson)

  console.log(sig.reqPublishResInfo, '发布视频')
  if (sig.reqPublishResInfo && sig.reqPublishResInfo.meetCode) {
    //可以返回会议编号，就表示申请成功了
    //异步启动自身
    startPublishMedia(sig.reqPublishResInfo)
  }
  //获取房间信息.
  getRoomInfo()
}
async function getRoomInfo() {
  //获取房间信息.
  sig.roomInfo = await sig.sigQueryRoom()
  console.log('获取房间信息', sig.roomInfo, sig.roomInfo.meetCode)
  if (sig.roomInfo && sig.roomInfo.meetCode) {
    //存在会议编号
    console.log('sig.roomInfo.meetCode=' + sig.roomInfo.meetCode)
    setTimeout(function() {
      //播放其它客户端
      playRoomClient(sig.roomInfo)
    }, 1000)
  }
}
//(覆盖回调方法) 房间内推流信息变化，服务器回调信息
sig.sigServerNotifyClientPublishChange = function(roomInfoJson) {
  console.log('服务器回调信息', roomInfoJson)
  if (roomInfoJson) {
    // 客户离开会议
    if (roomInfoJson.event === 'clientLeave') {
      let clients = []
      // 待做。。。。。。
      for (let item of roomInfoJson.clientList) {
        clients.push(item.clientCode)
        // if(item.clientCode !== current.helmetId) { //NOSONAR
        //   clientPlayers = {} //存放播放器对象 //NOSONAR
        // } //NOSONAR
      }
      if (clients.indexOf(current.helmetId) === -1) {
        clientPlayers = {} //存放播放器对象
      }
      clearTime = setTimeout(function() {
        if (clients.indexOf(current.helmetId) === -1) {
          alertWin(current.userName + '安全帽已掉线，无法自动重连，自动退出实时视频', handleHelmetLeave)
          leaveRoomSelf()
        }
      }, 10000)
    } else if (roomInfoJson.event === 'clientPublish') {
      clearTimeout(clearTime)
      sig.roomInfo = roomInfoJson
      //播放其它客户端
      if (publisher) {
        playRoomClient(sig.roomInfo)
      }
    }
  }
}

var publishtrack = null
// 请求推流
async function startPublishMedia(reqPublishResData) {
  if (publisher) {
    publisher.close()
  }
  var rtcSdpUrl = 'https://' + rtcUrl + '/hwmsp/media'
  publisher = new HwRtcPublisherAsync()
  // 开启打印
  publisher.openDebug()

  //覆盖sdk里面的通知推流成功的回调function
  publisher.callbackOnAddStream = function(event) {
    //event.stream是 浏览器的navigator.mediaDevices.getUserMedia对象

    publishtrack = event.stream.getAudioTracks()[0]
    console.log('流回调：', event.stream)
    // 静音
    muteMic()
    localSrsmuteMic()
  }
  //覆盖sdk里面的推流状态改变的回调function
  publisher.callbackOnPeerConnectionStateChange = function(event) {
    //event是连接事件对象
    console.log('override publish callbackOnPeerConnectionStateChange().. event: ', event)
    queryPublishConnectionState()
  }

  var rtcHostIp = '' //rtc服务器推流拉流使用udp协议。如果有多个ip或者需要代理ip才能传输流，可以通过这个参数传入指定的ip
  var publishVideo = false //传输视频
  var publishAudio = true //传输音频
  //定义浏览器webrtc推流参数
  //详细参数访问： https://developer.mozilla.org/zh-CN/docs/Web/API/MediaDevices/getUserMedia
  // var navigatorMediaInfo = { audio: true, video: { width: {   max: 300 } } }
  var navigatorMediaInfo = { audio: true, video: false }
  //推流
  publisher
    .publishStream(rtcSdpUrl, rtcHostIp, sig.myToken, navigatorMediaInfo, publishVideo, publishAudio)
    .then(function(session) {
      console.log('推流成功', session, new Date())
    })
    .catch(function(reason) {
      publisher.close()
      console.error('推流失败', reason)
    })
}
var queryPublishConnCount = 0
function queryPublishConnectionState() {
  if (!publisher) {
    return
  }
  //查询到连接当前状态
  var peerState = publisher.getPublishConnectionState()
  queryPublishConnCount++
  console.log('queryPublishConnectionState() peerState: ', peerState)
  if (peerState === 'failed' || peerState === 'closed') {
    console.log('推流已断开！！！')
    // 关闭实时视频框
    alertWin('当前安全帽网络环境较差或已掉线，请重试', handleHelmetLeave)
  } else if (peerState === 'disconnected') {
    if (queryPublishConnCount > 5) {
      console.log('推流已断开！！！')
      // alertWin('当前安全帽网络环境较差或已掉线，请重试', handleHelmetLeave)
      return
    }
    console.log('推流不稳定！！！')
    //3秒后再递归调用
    setTimeout(function() {
      queryPublishConnectionState()
    }, 3000)
  } else {
    queryPublishConnCount = 0
    console.log('')
  }
}

function playRoomClient(roomInfo) {
  lastestPlayers = {} //最新的客户端
  var waitDelPlayers = {} //待删除的客户端
  $.each(clientPlayers, function(tokenKey, obj) {
    //先判断正在播放的客户端已经失效
    if (!lastestPlayers[tokenKey]) {
      //不在的话，删除dev
      console.info('clientPlayer no alive. close window. dev=' + tokenKey)
      obj.player.close()
      waitDelPlayers[tokenKey] = tokenKey
    } else {
      //已经在播放，但可能已经不推流
      if (!lastestPlayers[tokenKey].publishing) {
        console.info('clientPlayer no publishing. close window. dev=' + tokenKey)
        obj.player.close()
        waitDelPlayers[tokenKey] = tokenKey
      } else {
        //delete lastestPlayers[tokenKey]; //NOSONAR
      }
    }
  })

  $.each(waitDelPlayers, function(tokenKey) {
    delete clientPlayers[tokenKey] //删除
  })

  roomInfo.clientList.forEach(function(clientInfo) {
    console.log('客户端信息', clientPlayers, !clientPlayers[clientInfo.token])
    //客户端信息不是自己的 && 在推流中 && 不在播放中
    if (
      clientInfo.token !== sig.myToken &&
      clientInfo.publishing &&
      !clientPlayers[clientInfo.token] &&
      clientInfo.clientCode === current.helmetId
    ) {
      console.log('播放其它客户端')
      setTimeout(function() {
        //播放其它客户端
        playClient(clientInfo)
      }, 500)
    } else if (clientInfo.token !== sig.myToken && clientInfo.publishing && !clientPlayers[clientInfo.token]) {
      setTimeout(function() {
        //播放其它web第三方客户端
        playWebClient(clientInfo)
      }, 500)
    }
  })
}
let video = null
//播放其它客户端
function playClient(clientInfo) {
  var cliToken = clientInfo.token
  if (!cliToken) {
    return
  }

  video = document.getElementById('mvcpVideo')
  video.srcObject = null
  console.log('.cliToken=' + cliToken)
  //创建其它客户端的rtc播放对象
  let rtcPlayerObj = new HwRtcPlayerAsync()
  // 开启打印
  rtcPlayerObj.openDebug()
  //
  clientPlayers[cliToken] = { video: video, player: rtcPlayerObj }

  //覆盖sdk里面的推流状态改变的回调function
  rtcPlayerObj.callbackOnPeerConnectionStateChange = function(event) {
    //event是连接事件对象
    console.log('override play callbackOnPeerConnectionStateChange().. event: ', event)
    queryPlayConnectionState(cliToken)
  }

  //覆盖sdk里面的回调通知function
  rtcPlayerObj.callbackOnAddStream = function(event) {
    //event.stream是 浏览器的navigator.mediaDevices.getUserMedia对象
    console.log('video override play callbackOnAddStream()..Start play, event: ', event)
    // video标签播放视频
    if (event.stream.id === 'default') {
      playClient(clientInfo)
    } else {
      setTimeout(() => {
        if (video) {
          video.srcObject = event.stream
        }
      }, 200)
    }
  }
  /*
  //根据属性生成地址
  // var rtcSdpUrl = 'https://' + clientInfo.serverIp + ':' + clientInfo.serverPortMap.httpsApi //NOSONAR
  */
  var rtcSdpUrl = 'https://' + rtcUrl + '/hwmsp/media'
  var rtcHostIp = '' //rtc服务器推流拉流使用udp协议。如果有多个ip或者需要代理ip才能传输流，可以通过这个参数传入指定的ip
  rtcPlayerObj
    .play(rtcSdpUrl, rtcHostIp, sig.myToken, cliToken)
    .then(function(session) {
      console.log('拉流成功:' + session, new Date())
      clearTimeout(closeNetTip)
    })
    .catch(function(reason) {
      console.log('拉流失败:' + reason)
      rtcPlayerObj.close()
      console.error(reason)
    })
}

var queryPlayConnCount = 0
function queryPlayConnectionState(cliToken) {
  if (!clientPlayers[cliToken]) {
    return
  }
  let rtcPlayerObj = clientPlayers[cliToken].player
  //查询到连接当前状态
  var peerState = rtcPlayerObj.getPlayConnectionState()
  queryPlayConnCount++
  console.log('queryPlayConnectionState()... cliToken=' + cliToken + '...peerState=' + peerState)
  if (peerState === 'failed' || peerState === 'closed') {
    console.log('拉流已断开！！！')
    alertWin(current.userName + '安全帽已掉线，无法自动重连，自动退出实时视频 拉流failed', handleHelmetLeave)
  } else if (peerState === 'disconnected') {
    if (queryPublishConnCount > 5) {
      console.log('拉流已断开！！！')
      return
    }
    console.log('拉流不稳定！！！')
    //3秒后再递归调用
    setTimeout(function() {
      queryPlayConnectionState(cliToken)
    }, 3000)
  }
}
// 拉取其他web端的流
function playWebClient(clientInfo) {
  var cliToken = clientInfo.token
  if (!cliToken) {
    return
  }

  let div = document.getElementById('mvcpAudio1')
  // 生成audio标签
  let audioObj = document.createElement('audio')
  // 给audio标签添加id
  audioObj.setAttribute('id', `id${clientInfo.clientCode}`)
  // 设置自动播放
  audioObj.setAttribute('autoplay', true)
  // 插入mvcpAudio1
  div.appendChild(audioObj)
  let audio = document.querySelectorAll(`#id${clientInfo.clientCode}`)[0]

  console.log('.cliToken=' + cliToken)
  //创建其它客户端的rtc播放对象
  let rtcPlayerObj = new HwRtcPlayerAsync()
  // 开启打印
  rtcPlayerObj.openDebug()
  //
  clientPlayers[cliToken] = { audio: audio, player: rtcPlayerObj }

  //覆盖sdk里面的推流状态改变的回调function
  rtcPlayerObj.callbackOnPeerConnectionStateChange = function(event) {
    //event是连接事件对象
    console.log('override play callbackOnPeerConnectionStateChange().. event: ', event)
    queryPlayConnectionState(cliToken)
  }

  //覆盖sdk里面的回调通知function
  rtcPlayerObj.callbackOnAddStream = function(event) {
    //event.stream是 浏览器的navigator.mediaDevices.getUserMedia对象
    console.log(' audio override play callbackOnAddStream()..Start play, event: ', event)
    // audio标签播放视频  && clientInfo.clientCode === current.helmetId

    if (audio) {
      audio.srcObject = event.stream
    }
  }
  var playVideo = false //传输视频
  var playAudio = true //传输音频
  /*
  // var port = 80
  // if (clientInfo.serverPortMap && clientInfo.serverPortMap.httpsApi) {
  //   port = clientInfo.serverPortMap.httpsApi
  // }
  //根据属性生成地址
  // var rtcSdpUrl = 'https://' + clientInfo.serverIp + ':' + clientInfo.serverPortMap.httpsApi
  */
  var rtcSdpUrl = 'https://' + rtcUrl + '/hwmsp/media'

  var rtcHostIp = '' //rtc服务器推流拉流使用udp协议。如果有多个ip或者需要代理ip才能传输流，可以通过这个参数传入指定的ip
  rtcPlayerObj
    .play(rtcSdpUrl, rtcHostIp, sig.myToken, cliToken, playVideo, playAudio)
    .then(function(session) {
      console.log('其他web端拉流成功:' + session, new Date())
    })
    .catch(function(reason) {
      console.log('拉流失败:' + reason)
      rtcPlayerObj.close()
      console.error(reason)
    })
}
async function delectMeet() {
  await handleHeader()
  deleteMeet({ code: meetCode }, tokenData, reqCode, reqTime, sign).then(res => {
    if (res.state === 0) {
      console.log('通过会议码删除会议。')
    }
  })
}
/**
 * 远端流静音（暂停生产流）
 */
async function muteMic() {
  if(video) {
    video.pause()
  }
  let audioArr = document.getElementById('mvcpAudio1')
  audioArr.childNodes.forEach(element => {
    element.muted = true
  })
}

/**
 * 远端流解除静音（恢复生产流）
 */
async function unmuteMic() {
  video.play()
  let audioArr = document.getElementById('mvcpAudio1')
  audioArr.childNodes.forEach(element => {
    element.muted = false
  })
}

/**
 * 本地静音（暂停生产流）
 */
async function localSrsmuteMic() {
  if (publishtrack) {
    publishtrack.enabled = false
  }
  console.log('静音（暂停生产流）', publishtrack)
}

/**
 * 本地解除静音（恢复生产流）
 */
async function localSrsunmuteMic() {
  if (publishtrack) {
    publishtrack.enabled = true
  }
  console.log('解除静音（恢复生产流）', publishtrack)
}

/**
 * 检查是否是否有麦克风，若没有，则直接返回
 */
async function checkMic() {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true })
    hasMic = true
    volume = 1
  } catch (error) {
    if (error.message === 'Requested device not found') {
      console.error('您的计算机未找到麦克风设备')
    } else {
      console.error('checkMic error', error)
    }
    volume = 0
    hasMic = false
  }
}

// 生成随机数字符串
function randomNumstr(length) {
  if (typeof length != 'number') {
    length = 4
  }
  var numStr = ''
  for (var i = 0; i < length; i++) {
    numStr += Math.floor(Math.random() * 10)
  }
  return numStr
}

/**
 * 业务代码
 */
if (getSession('access_token') && store.getters.rtcType === 'srs' && !window.location.href.includes('Intercom') && !window.location.href.includes('/externalHistory')) {
  // register()
}

/**
 * 加入视频会议
 * @param {*} helmetId 安全帽序列号
 * @param {*} resolutionP 清晰度
 * @param {*} userId 用户id
 * @param {*} userName 用户名
 */

async function noticeHelmetMeet(helmetId, resolutionP) {
  // action为0是加入安全帽
  var sendMsg = {
    action: ACION_REQUEST.JION_ROOM,
    content: {
      g_meet_id: null,
      g_meet_pwd: null,
      meetCode: meetCode,
      resolution: resolutionP,
      // 0=关闭声音，1=打开声音n
      volume: volume,
      // transcribe: true
    },
  }
  console.log(helmetId, resolutionP, '发送加入房间请求', new Date())
  CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
  // 5秒内接收不到安全帽返回消息，提示网络延迟请重试
  if (CHAT.socket.readyState === WebSocket.OPEN) {
    closeNetTip = setTimeout(() => {
      // 关闭实时视频框
      alertWin('当前安全帽网络环境较差或已掉线，请重试', handleHelmetLeave)
    }, 15000)
  }
}

/**
 * 切换视频分辨率
 * @param {*} helmetId 安全帽序列号
 * @param {*} resolutionP 清晰度
 */
async function changeResolutionP(helmetId, resolutionP) {
  current.resolutionP = resolutionP
  // action为2，通知安全帽切换分辨率，resolution代表流畅度
  var sendMsg = {
    action: ACION_REQUEST.SWITCH_RESOLUTION,
    content: {
      resolution: resolutionP,
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
}

// 即将离开当前页面(刷新或关闭)
window.onbeforeunload = window.onpagehide = function() {
  helmetExitMeet(current.helmetId)
  leaveRoomSelf()
}

/**
 * 通知安全帽退出房间
 * @param {*} exitHelmetId 退出安全帽id
 */
function helmetExitMeet(exitHelmetId) {
  //记录近一次关闭安全帽实时视频的时间
  closeTime = new Date()
  //记录近一次关闭安全帽实时视频的时间
  var sendMsg = {
    action: ACION_REQUEST.EXIT_ROOM,
    content: {
      webPeerId: null,
      meetCode: meetCode,
    },
  }
  clearTimeout(closeNetTip)
  CHAT.chat(websocketapp.HELMET_OPERATION, exitHelmetId, sendMsg)
}

/**
 * 实时视频操作响应处理，需结合具体业务调整
 * @param {Object} params 接收响应params参数
 */
async function handleHelmetOperationResponse(params) {
  console.log(params, 'params')
  if (params.helmetId !== current.helmetId) {
    // 当收到别的安全帽的信息时不进行任何处理
    return
  }
  var status = JSON.parse(params.status)
  if (status.action === 2) {
    clearTimeout(closeNetTip)
    console.log('安全帽加入房间结果：' + status.enterResult, new Date())
    if (!status.enterResult) {
      clearTimeout(clearTime)
      alertWin(current.userName + i18n.t('videoConnectionFailed'), handleHelmetLeave)
    }
    setTimeout(() => {
      if (
        document.getElementById('mvcpVideo') &&
        document.getElementById('mvcpVideo').srcObject === null &&
        status.enterResult
      ) {
        console.log('重新获取房间信息：')
        getRoomInfo()
      }
    }, 2000)

    return
  }
  if (status.action === 1) {
    console.log(`拍照状态:${status.camera}`)
    return
  }
  // 如果头盔已经在会议中，则直接加入会议
  if (
    status.meetCode &&
    status.meetCode !== '' &&
    document.getElementById('mvcpVideo') &&
    document.getElementById('mvcpVideo').srcObject === null
  ) {
    hasEnterRoom = true
    clearTimeout(closeNetTip)
    if (publisher) {
      publisher.close()
    }
    if (sig) {
      sig.sigClose()
    }
    meetCode = status.meetCode
    setTimeout(() => {
      loginMVCPUtil(status.meetCode)
    }, 1500)
    setTimeout(() => {
      starPlay()
      if (store.state.helpVideo) {
        unmuteMic()
        localSrsunmuteMic()
      }
    }, 2000)
  }
  if (status.isFaceScan) {
    warning(current.userName + '安全帽正在进行人脸识别，请稍后连接!')
    return
  }
  if (status.isQRScan) {
    warning(current.userName + '安全帽正在进行二维码扫描，请稍后连接!')
    return
  }
  if (status.isSwitchUser) {
    warning(current.userName + '安全帽正在进行切换用户，请稍后连接!')
    return
  }
  if (status.isAgoraSpeech) {
    warning(current.userName + '麦克风已被占用!')
    return
  }
  if (status.isRecord) {
  console.log('status.isRecord', current.userName)
    confirmWin(
      current.userName + i18n.t('RecordingPreemptOrNot'),
      () => {
        // 点击确定，抢占录像
        grabRecord(params.helmetId)
      },
      () => {
        // 点击取消事件 关闭直播框
        handleHelmetLeave()
      }
    )
    return
  }
  // console.log(status.resolution, current.resolutionP, params.helmetId, current.helmetId)
  if (
    status.resolution &&
    status.resolution !== current.resolutionP &&
    params.helmetId === current.helmetId &&
    !params.liveUrl
  ) {
    store.commit('handleresolutionP', status.resolution)
    warning('其他用户修改了分辨率，已为您自动切换分辨率!')
  }
}

/**
 * 抢占视频
 */
function grabRecord(helmetId) {
  var sendMsg = {
    action: 4,
    content: {
      g_meet_id: null,
      g_meet_pwd: null,
      meetCode: meetCode,
      resolution: current.resolutionP,
      volume: VOLUME_ON,
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
}

export { VOLUME_OFF, VOLUME_ON }

export {
  setHandleHelmetOperationResponse,
  setHandleHelmetLeave,
  handleHelmetOperationResponse,
  helmetJoinMeet,
  grabRecord,
  helmetExitMeet,
  changeResolutionP,
  muteMic,
  unmuteMic,
  leaveRoomSelf,
  loginMVCPUtil,
  registerAlone,
  loginOutCloseSig,
  localSrsmuteMic,
  localSrsunmuteMic
}
